import React from "react";
import Intercom from "react-intercom";
import { string } from "prop-types";

const LiveChat = ({ email, name }) => {
  return <Intercom appID="dj3h8cb0" email={email} name={name} />;
};

LiveChat.propTypes = {
  email: string.isRequired,
  name: string.isRequired
};

export default LiveChat;



// WEBPACK FOOTER //
// ./src/views/components/live_chat/LiveChat.jsx